function normalize(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function isHumanMelding(melding = {}) {
  if (melding?.isAutomatic === true || melding?.isAutoMelding === true) return false;
  const source = normalize(melding?.source || melding?.origin || melding?.meldingType || melding?.type);
  return !['automatic', 'auto', 'system', 'telemetry', 'cycle'].includes(source);
}

export function isUnreadHumanMelding(melding = {}, branchId = null) {
  if (!isHumanMelding(melding)) return false;
  const expected = normalize(branchId);
  if (!expected) return false;
  const actual = normalize(melding?.branchId || melding?.vestigingId || melding?.branchName || melding?.vestiging);
  if (actual !== expected) return false;
  const readValue = melding?.isRead ?? melding?.gelezen ?? melding?.read ?? melding?.seen ?? melding?.viewed;
  const readTimestamp = melding?.readAt || melding?.gelezenOp || melding?.viewedAt;
  return readValue === false || readValue === 'false' || (!readValue && !readTimestamp && Object.prototype.hasOwnProperty.call(melding, 'isRead'));
}

export function countUnreadHumanMeldingen(meldingen = [], branchId = null) {
  return (Array.isArray(meldingen) ? meldingen : []).filter((melding) => isUnreadHumanMelding(melding, branchId)).length;
}
